import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var WifiOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M8.456 37.552c-.417.416-.438 1.07-.047 1.461.39.39 1.045.37 1.46-.046l15.456-15.455a11.031 11.031 0 0 1 6.874 6.36l1.515-1.515a13.05 13.05 0 0 0-6.827-6.407l3.747-3.748a18.086 18.086 0 0 1 6.764 6.47l1.451-1.45a20.102 20.102 0 0 0-6.748-6.487l3.63-3.63a25.138 25.138 0 0 1 6.72 6.514l1.434-1.434a27.152 27.152 0 0 0-6.712-6.521l4.23-4.23c.416-.417.437-1.07.046-1.461-.39-.39-1.044-.37-1.46.046L8.455 37.552ZM18.026 23.74l2.675-2.676c-4.448.441-8.235 3.124-10.218 6.9-.068.13-.134.26-.198.393l1.515 1.515a11.04 11.04 0 0 1 6.226-6.132ZM25.437 16.328l1.67-1.67A20.026 20.026 0 0 0 21.999 14c-7.078 0-13.296 3.677-16.85 9.221l1.452 1.452C9.758 19.472 15.474 16 21.999 16c1.176 0 2.325.113 3.438.328Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m31.07 10.696 1.533-1.534A26.913 26.913 0 0 0 22 7C12.994 7 5.02 11.409.113 18.185l1.434 1.434C6.072 13.196 13.545 9 22 9c3.2 0 6.258.6 9.07 1.696ZM26 34a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }));
});
WifiOff.displayName = 'WifiOff';
WifiOff.defaultProps = {
  'aria-label': 'WifiOff'
};
export default WifiOff;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/WifiOff.js
// module id = 3958
// module chunks = 11